import { Box, MenuItem, Select } from "@mui/material";
import * as React from "react";
import { FormSectionTitle } from "source/components/framework/Form/FormSectionTitle";
import { IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { IRecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";
import { Translations } from "ui/Scripts/source/models/translations";
import { IRecordEditItemFurtherEducation } from "../../../models/record/recordEditItemFurtherEducation";
import { IRecordEditItemQualification } from "../../../models/record/recordEditItemQualification";
import { IRecordEducationListItem } from "../../../models/recordEducation/recordEducationListItem";
import { RecordEditFurtherEducationList } from "./RecordEditFurtherEducationList";

export interface IRecordEditEducationProp {
    isNew: boolean;
    companyId: string;
    recordId: string;
    userCode: string;
    basicEducationId: string;
    recordQualifications: IRecordEditItemQualification[];
    recordFurtherEducations: IRecordEditItemFurtherEducation[];
    basicEducations: IRecordEducationListItem[];
    furtherEducationGroups: IRecordFurtherEducationGroupNode[];
    attachments: IFileAttachment[];
    onChange: (name: string, value: string) => void;
    onFurherEducationRemoved: (ids: string[]) => void;
    onFurherEducationSaved: (recordFurtherEducation: IRecordEditItemFurtherEducation) => void;
    onAttachmentsRemoved: (ids: string[]) => void;
    onAttachmentsAdded: (attachments: IFileAttachment[]) => void;
}

export class RecordEditEducation extends React.Component<IRecordEditEducationProp, {}> {
    handleChange = (event) => {
        const target = event.target;
        this.props.onChange(target.name, target.value);
    };
    
    render() {
        const props = this.props;
        return (
            <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <Box>
                    <FormSectionTitle margin="-0.5rem 0 .5rem 0">{Translations.BasicEducation}</FormSectionTitle>
                    <Select name="basicEducationId" title={Translations.BasicEducation} value={props.basicEducationId} onChange={this.handleChange} size="small" fullWidth sx={{ maxWidth: "400px" }}>
                        {props.basicEducations.map(basicEducation =>
                            <MenuItem key={basicEducation.id} value={basicEducation.id}>{basicEducation.code}</MenuItem>
                        )}
                    </Select>
                </Box>
                <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                    <Box>
                        <FormSectionTitle margin="1rem 0 -0.5rem 0">{Translations.FurtherEducations + " / " + Translations.Competencies}</FormSectionTitle>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                            <RecordEditFurtherEducationList
                                isReadOnly={props.isNew}
                                companyId={props.companyId}
                                recordId={props.recordId}
                                userCode={props.userCode}
                                recordQualifications={props.recordQualifications}
                                recordFurtherEducations={props.recordFurtherEducations}
                                furtherEducationGroups={props.furtherEducationGroups}
                                attachments={props.attachments}
                                onRemoved={props.onFurherEducationRemoved}
                                onSaved={props.onFurherEducationSaved}
                                onAttachmentsRemoved={props.onAttachmentsRemoved}
                                onAttachmentsAdded={props.onAttachmentsAdded}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }
}